<div class="lock-main">
  <div class="header mt-3 mb-2 pb-3">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        [class.hide]="stepper === 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ "ADD_A_LOCK" | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>

    <div class="d-flex mt-2 pt-2">
      <h2 class="heading1 m-auto">{{ "ENTER_LOCK_INFO" | translate }}</h2>
    </div>

    <div class="d-flex pt-2">
      <h2 class="heading2 m-auto">
        {{ "ENTER_INFO_LISTED_YOUR_LOCK" | translate }}
      </h2>
    </div>
  </div>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
    <div class="form-group rounded-top form-container mb-293">
      <mat-form-field appearance="fill" class="w-100 mb-2 primary-input">
        <mat-label>{{ "SERIAL_NUMBER" | translate }}</mat-label>
        <input
          matInput
          placeholder="Ex. e4abd7093dcf8734"
          formControlName="deviceId"
        />
        <mat-error>
          <span *ngIf="formGroup?.controls?.deviceId?.errors?.required">{{
            "YOU_MUST_ENTER_SERIAL_NUMBER" | translate
          }}</span>
        </mat-error>

        <mat-error>
          <span *ngIf="formGroup?.controls?.deviceId?.errors?.hexadecimal">{{
            "SERIAL_NUMBER_ALPHA_NUMERIC" | translate
          }}</span>
        </mat-error>

        <mat-error *ngIf="formGroup?.controls?.deviceId?.errors?.whitespace"
          >{{ "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            formGroup?.controls?.deviceId?.errors?.maxlength &&
            !formGroup?.controls?.deviceId?.errors?.hexadecimal
          "
        >
          {{
            commonService.stringInterPolation(
              "MAXIMUM_OF_CHARACTERS" | translate,
              "16"
            )
          }}
        </mat-error>
        <mat-error
          *ngIf="
            formGroup?.controls?.deviceId?.errors?.minlength &&
            !formGroup?.controls?.deviceId?.errors?.hexadecimal
          "
        >
          {{
            commonService.stringInterPolation(
              "MINIMUM_OF_CHARACTERS" | translate,
              "16"
            )
          }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          [disabled]="formGroup?.invalid"
          type="submit"
        >
          {{ "CONTINUE" | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
